module.exports = __webpack_public_path__ + "static/img/status-icon.d28e5d12.png";